import { Component, type ReactNode } from 'react';
import { trackError } from '../../services/TrackJs';

type Props = {
    renderFallback?: (error: unknown) => ReactNode;
    children: ReactNode;
};

export default class ErrorBoundary extends Component<Props, { error: unknown | null }> {
    state = {
        error: null,
    };

    static getDerivedStateFromError(error: unknown) {
        return { error };
    }

    componentDidCatch(error: Error) {
        trackError(error);
    }

    render() {
        if (this.state.error) {
            return this.props.renderFallback?.(this.state.error);
        }
        return this.props.children;
    }
}
